import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent, MenuItem } from '../../components/shared/menu-component/menu-component';
import { AuthService } from '../../services/auth-service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-load-management-report',
  standalone: true,
  templateUrl: './load-management-report-component.html',
  styleUrls: ['./load-management-report-component.scss'],
  imports: [
    CommonModule,
    MenuComponent
  ]
})
export class LoadManagementReportComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  menu: MenuItem[] = [];

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    this.authService.getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe(userInfo => {
        if (userInfo) {
          if (userInfo.isDeliverySupervisor) {
            this.menu = [
              { title: 'Unassigned Orders', icon: 'assignment_late', link: '/load-ua', disabled: false, count: 0 },
              { title: 'Load', icon: 'inventory_2', link: '/load-report', disabled: false, count: 0 },
              { title: 'Delivery', icon: 'local_shipping', link: '/delivery-report', disabled: false, count: 0 },
              { title: 'Report', icon: 'insert_chart', link: '/load-delivery-report', disabled: false, count: 0 }
            ];
          } else {
            this.menu = [
              { title: 'Unassigned Orders', icon: 'assignment_late', link: '/load-ua', disabled: false, count: 0 },
              { title: 'Load', icon: 'inventory_2', link: '/load-report', disabled: false, count: 0 }
            ];
          }
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
